import elementResizeDetectorMaker from "element-resize-detector";
// 去除前后空格
export function trim(value) {
  if (typeof value == "string" && value) {
    return value.replace(/(^\s*)|(\s*)$/g, "");
  } else {
    return "";
  }
}

export function isEmpty(value) {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    JSON.stringify(value) === "{}" ||
    JSON.stringify(value) === "[]"
  );
}

// 枚举列表取值
export function parseCommonEnum(value, list, params) {
  const opt = {
    split: "",
    key: "value",
    value: "label",
    none: "",
    ...params,
  };
  if (!list || isEmpty(value)) return opt.none;
  if (Array.isArray(list)) {
    if (opt.split) {
      let resArray = [];
      value.split(opt.split).map((val) => {
        if (!isEmpty(val)) {
          const res = list.find((v) => v[opt.key] === val);
          resArray.push(res ? res[opt.value] : opt.none);
        }
      });
      return resArray.join(opt.split);
    } else {
      const res = list.find((val) => val[opt.key] === value);
      return res ? res[opt.value] : opt.none;
    }
  }
  if (typeof list === "object") {
    if (opt.split) {
      let resArray = [];
      value.split(opt.split).map((val) => {
        if (!isEmpty(val)) {
          resArray.push(list[val] === undefined ? opt.none : list[val]);
        }
      });
      return resArray.join(opt.split);
    } else {
      return list[value] === undefined ? opt.none : list[value];
    }
  }
  return opt.none;
}

// 获取当前时间
export function getNowDate(str, type) {
  let now = str ? str : new Date();

  let year = now.getFullYear();
  let mouth = now.getMonth() + 1;
  let date = now.getDate();
  let hours = now.getHours();
  let minutes = now.getMinutes();
  let days = now.getDay();
  let seconds = now.getSeconds();
  if (type == "date") {
    return (
      year +
      "-" +
      (mouth < 10 ? "0" + mouth : mouth) +
      "-" +
      (date < 10 ? "0" + date : date) +
      " " +
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds)
    );
  } else if (type == "week") {
    let weeks = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ];
    let week = weeks[days];
    return week;
  } else {
    return (
      year +
      "-" +
      (mouth < 10 ? "0" + mouth : mouth) +
      "-" +
      (date < 10 ? "0" + date : date)
    );
  }
}

// 动态调整页面大小
export function resizeDetector(that, chartId) {
  // 使用基于滚动的超快速方法
  // 这是推荐的策略
  let resize = elementResizeDetectorMaker({
    strategy: "scroll", // 为了超高性能
  });
  resize.listenTo(document.getElementById(chartId), (element) => {
    that.$nextTick(() => {
      // 使echarts尺寸重置
      that.$echarts.init(document.getElementById(chartId)).resize();
    });
  });
}
// 图表无数据展示
export function setNotopt(dom, subtext = "暂无数据") {
  var option = {
    title: {
      text: " {a|}",
      x: "center",
      y: "center",
      subtext,
      itemGap: 10,
      backgroundColor: "#F8F8F8",
      textStyle: {
        rich: {
          a: {
            color: "#000",
            fontSize: "14",
            height: 44,
            width: 44,
            backgroundColor: {
              image:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAA0JJREFUWEftmWeLFEEQQN/pmXNWzIo5oZi/6H9XMCKiomKOGFBRMZ6Rd9YsO3M7uzPj9e0eXMFxu0tP95vqquqq6iH+yWxgFTAjvvfz32/gPfCuE8QQsBjYB0zvJ2WHtZ8B94q/C3wYmA88Bj4NALSK2wLMBC4XmQQ+BYwA5wYANkPYCqwHbgGv2rkEPg18A84PEPBmYCNwG3g5BZxgZ6Y0nECpuSn/W8M653jLny4TNgY2Jh6LmDjewIbSi8DPDhM3Bp4Wp+Cs8aaN2H8N8CguSmPgBJyVppwCrqSm/xg0aTU8aXKJBcAm4G7kOa3NGtTkp9SaqgAPA/5Vle9At0OhfR7DZqew1hhY0OM1gS1vrpasuAxYEVWOCbrAP4AvwNtIJT1QGgO7Azui5quqYRd+Whi8ENgGaJuKWhXsV5yiWS3pd0ujR2W7VMUkqoKWjVsNbA9tfoiXscBsN4W5UQSvi9rScTdC+7l5UwO7/btDW3eK1UOHN9RM9gCLgI9hWjkbTwls6+BIaPZ6WdneAVq73h92PqZyTgm8K7b5YVTkdUxLmz4a5nEJ+Jo9nArYrT0RjnWhbugKOKtmq+ecllMBr4no0rEZUlHVavkkYFxvVfRVgOf0SOANT60tCxhD2FpA2zXMNRV9YB5wJkIgvYA9OHxLHaFM9GKbMB4AmejpRogxnZua5Drf0qhMPFx6AjvGVE+PLxObMDpWuxjKVgJXIjzV5GwNPwAsAfSD0V3speGmC2WtppvA66aTRD2pss5WNYmma2kOmoVtJttNTUTfsQC2QalpjUoqDVtta/uK29k1oSl5m8xxc3E8FbAMtkw3RPfRyqGO2P49FEe6Ia3l0CmBjTD2nrXBB8CTisS2FA7Gc1Ycz9ufSwnsOmrKxTWRF8D9ksZJxmQI2xlx3yLAvNrMrSWpgV3IHHgvoObcWh3Rw8QwleXDZmfesXh9oQjpb3aFbLaYuSV1uuLum1tYVHpkd+vTeThoPm/C/vWDHPREaLgdXi0vD036WVMxgnyO9LN4c6TT5qAnGrii3+WG5aAH9VKm+GIZ9Eg/rr00gZznV1S79j/cr4tF+8Kj2VddyTx2Iq9uDW0eIlWbLbl3+gvxJPmSOjSj8AAAAABJRU5ErkJggg==",
            },
          },
        },
      },
      subtextStyle: {
        fontSize: 14,
      },
    },
  };
  dom.setOption(option, true);
}
